export function Logo({ variant = "light", className = "", height = 24 }) {
  // Transparent Millionaire Mindsetters™ wordmark. Silver for dark surfaces, navy for light.
  const src = variant === "light" ? "/mmt-logo-light.png" : "/mmt-logo.png";
  return (
    <img
      src={src}
      alt="Millionaire Mindsetters"
      data-testid="mmt-logo"
      className={className}
      style={{ height, width: "auto", objectFit: "contain" }}
    />
  );
}
